import { Map } from 'immutable';
import is from 'is_js';
import PersonalisedHomework from './model';
import { status as HomeworkStatus } from 'data/Homework';
import {
  FETCH_PERSONALISED_HOMEWORK_SUCCESS,
  SUBMIT_PERSONALISED_HOMEWORK_SUCCESS,
  DELETE_PERSONALISED_HOMEWORK_SUCCESS,
  PUBLISH_PERSONALISED_HOMEWORK_SUCCESS,
} from './actions';

export default function personalisedHomeworkReducer(state = new Map(), action) {
  let model = action.model;
  switch (action.type) {
    case FETCH_PERSONALISED_HOMEWORK_SUCCESS:
      return addPersonalisedHomeworkToMap(state,
        Object.assign({}, action.payload, { status: action.status })
      );
    case SUBMIT_PERSONALISED_HOMEWORK_SUCCESS:
      if (is.not.existy(action.model.id)) {
        model = action.model.set('id', action.payload);
      }
      return addPersonalisedHomeworkToMap(state, model);
    case DELETE_PERSONALISED_HOMEWORK_SUCCESS:
      return deletePersonalisedHomeworkFromMap(state, action.personalisedHomeworkId);
    case PUBLISH_PERSONALISED_HOMEWORK_SUCCESS:
      return publishPersonalisedHomework(state, action.phId);
    default:
      return state;
  }
}

function addPersonalisedHomeworkToMap(state, data) {
  const ph = PersonalisedHomework.create(data);
  return state.set(ph.id, ph);
}

function deletePersonalisedHomeworkFromMap(state, phId) {
  return state.delete(phId);
}

function publishPersonalisedHomework(state, phId) {
  const ph = state.get(phId).set('status', HomeworkStatus.PUBLISHED);
  return state.set(phId, ph);
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/Personalised/reducer.js